/**
 * Util for creating partially applied map function. Useful for lifting a map into a promise.
 */
export function map<T, U>(fn: (t: T) => U) {
    return (array: T[]) => array.map(fn)
}
